<template>
  <div>
    <bm-text
      v-bind="$attrs"
      ref="barcodeScannerField"
      :value="value"
      :rules="computedRules"
      data-qa="scan_item_manual_input"
      clearable
      @keydown="emit('keydown', $event)"
      @update:value="emit('update:value', $event)"
      @blur="allowKeyboard = false"
    >
      <template #append-outer>
        <slot name="append-outer"></slot>
      </template>
    </bm-text>

    <slot name="action"></slot>
    <slot v-if="!disableCameraInput" name="scanner">
      <barcode-scanner2d
        :rules="computedRules"
        @valid-scanned="emit('valid-scanned', $event)"
        @loading="emit('loading', $event)"
      >
      </barcode-scanner2d>
    </slot>
  </div>
</template>

<script setup lang="ts">
import BmText from "@/components/controls/input/BmText.vue";
import BarcodeScanner2d from "@/components/controls/device/barcodes/BarcodeScanner2d.vue";
import type { ValidationRule } from "@/plugins/validation";
import { makeRef } from "@/components/composables/reactivityTypes";

interface Props {
  value?: string;
  computedRules?: ValidationRule[];
  disableCameraInput?: boolean;
}

interface Events {
  (event: "keydown", e: KeyboardEvent): void;
  (event: "update:value", value: string): void;
  (event: "valid-scanned", value: string): void;
  (event: "loading", loading: boolean): void;
}

withDefaults(defineProps<Props>(), {
  value: "",
  computedRules: () => [],
  disableCameraInput: false,
});

const emit = defineEmits<Events>();

const allowKeyboard = makeRef(false);
</script>
